import ComponentElement from 'components/component-element';
import {generateHash} from 'methods/utils';

function Accordion($element, options = {}) {
    ComponentElement.call(this, $element, options);

    const idHead = `accordion-${generateHash(6)}`;
    const idBody = `accordion-${generateHash(6)}`;

    this.$head = this.$element.querySelector('.js-head');
    this.$body = this.$element.querySelector('.js-body');
    this.$content = this.$element.querySelector('.js-content');

    this.$body.setAttribute('id', idBody);
    this.$body.setAttribute('role', 'region');
    this.$body.setAttribute('aria-labelledby', idHead);

    this.$opener = this.$head.querySelector('.js-opener');
    this.$opener.addEventListener('click', this._onOpenerClickEvent.bind(this));
    this.$opener.addEventListener('keydown', this._onOpenerKeydownEvent.bind(this));
    this.$opener.setAttribute('id', idHead);
    this.$opener.setAttribute('aria-controls', idBody);
    this.$opener.__hasDefaultTitle = this.$opener.hasAttribute('title');

    this.update();
}

Accordion.prototype = Object.create(ComponentElement.prototype);
Object.defineProperty(Accordion.prototype, 'constructor', {
    value: Accordion,
    enumerable: false,
    writable: true,
});

Accordion.prototype.opened = function () {
    return this.$element.classList.contains('is-opened');
}

Accordion.prototype.closed = function () {
    return !this.opened();
}

Accordion.prototype.open = function () {
    this.$element.classList.add('is-opened');
    this.update();
}

Accordion.prototype.close = function () {
    this.$element.classList.remove('is-opened');
    this.update();
}

Accordion.prototype.toggle = function () {
    if (this.opened()) {
        this.close();
    } else {
        this.open();
    }
}

Accordion.prototype.update = function () {
    this.$opener.setAttribute('aria-expanded', this.opened());

    if (!this.$opener.__hasDefaultTitle) {
        this.$opener.title = this.opened() ? 'Свернуть' : 'Развернуть';
    }
}

Accordion.prototype._onOpenerClickEvent = function (e) {
    this.toggle();
}

Accordion.prototype._onOpenerKeydownEvent = function (e) {
    if (e.code == 'Space' || e.code == 'Enter' || e.code == 'NumpadEnter') {
        e.preventDefault();
        this.toggle();
    }
}

export default Accordion;
